export class Lookup<V, K = string> extends Map<K, V> {
  static from<V extends { id: string }>(entries: readonly V[]): Lookup<V, string>;
  static from<V, K>(entries: readonly V[], selector: (x: V) => K): Lookup<V, K>;
  static from(entries: readonly any[], selector: (value: any) => any = (x) => x.id) {
    return new Lookup(entries.map((x) => [selector(x), x]));
  }
}

export class MultiLookup<V, K> extends Map<K, V[]> {
  static from<V, K>(entries: readonly V[], selector: (x: V) => K | readonly K[]): MultiLookup<V, K> {
    const lookup = new MultiLookup<V, K>();

    for (const x of entries) {
      const keys = selector(x);
      for (const key of Array.isArray(keys) ? keys : [keys]) {
        const value = lookup.get(key) ?? [];
        lookup.set(key, [...value, x]);
      }
    }

    return lookup;
  }

  get(key: K): V[] {
    return super.get(key) ?? [];
  }
}
